import { useState } from "react";
import { motion } from "framer-motion";
import { e2p, isValidPhonenNumber, p2e } from "../utils";
import { useNavigate } from "react-router-dom";
import { handleApiError } from "../utils/handleApiError";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "../config";
import useAuthStore from "../store/auth.store";
import { ClipLoader } from "react-spinners";
import { twMerge } from "tailwind-merge";

const PhoneNumberScreen = () => {
  const navigate = useNavigate();

  const [error, setError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const username = useAuthStore((state) => state.username);
  const setUsername = useAuthStore((state) => state.setUsername);

  const handleSubmit = async () => {
    try {
      if (!isValidPhonenNumber(p2e(username as string))) {
        setError("شماره موبایل معتبر نیست");
        return;
      }

      setIsLoading(true);

      await axios.post(API_BASE_URL + "v1/auth/login/", {
        phone_number: 98 + p2e(username?.slice(1) as string),
        organization: 1,
      });

      setError("");
      toast.success("کد اعتبارسنجی با موفقیت ارسال شد.");
      navigate("/auth/enter-otp");
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center px-4">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-black text-xl font-bold leading-relaxed mb-6"
      >
        شماره تلفن همراه خود را
        <br />
        وارد نمایید
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="w-full max-w-xs"
      >
        <input
          type="text"
          inputMode="numeric"
          placeholder="شماره همراه"
          value={username ? e2p(username as string) : ""}
          onChange={(e) => setUsername(p2e(e.target.value))}
          className="w-full text-center text-black text-xl font-semibold rounded-xl py-3 px-4 outline-none border-2 border-gray-200 focus:border-blue-400"
        />
        {error && <p className="text-red-500 text-lg mt-2">{error}</p>}
      </motion.div>

      <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        onClick={handleSubmit}
        className={twMerge(
          "mt-6 text-white min-w-[8rem] px-8 py-3 rounded-xl text-lg md:text-xl font-bold shadow-lg hover:bg-blue-600 transition",
          isLoading ? "bg-[#2a95db]" : "bg-[#2a95db]"
        )}
      >
        {isLoading ? <ClipLoader color="#fff" size={24} /> : "تایید"}
      </motion.button>
    </div>
  );
};

export default PhoneNumberScreen;
